
import './V_Container.scss'
import { images } from '../../../constants'
import React from 'react'
import { useState, useEffect } from 'react';
const V_Container= ({data}) => {
  return (
    <div className='event-container'>
      <div className="event_background_card">
        <img src={images[data.img]} alt="me" />
      </div>
      <div className="event__content">
        <h3>{data.title}</h3>
        <h4>{data.date}</h4>

        <p className='p-text'>{data.description}</p>
      </div>
    </div>
  )
}

export default V_Container